// Comprehensive country dial-code list (flag, dial code, name, iso)
export const COUNTRIES = [
  { iso: "CH", flag: "🇨🇭", dial: "+41", name: "Switzerland" },
  { iso: "DE", flag: "🇩🇪", dial: "+49", name: "Germany" },
  { iso: "AT", flag: "🇦🇹", dial: "+43", name: "Austria" },
  { iso: "FR", flag: "🇫🇷", dial: "+33", name: "France" },
  { iso: "IT", flag: "🇮🇹", dial: "+39", name: "Italy" },
  { iso: "GB", flag: "🇬🇧", dial: "+44", name: "United Kingdom" },
  { iso: "US", flag: "🇺🇸", dial: "+1", name: "United States" },
  { iso: "LI", flag: "🇱🇮", dial: "+423", name: "Liechtenstein" },
  { iso: "ES", flag: "🇪🇸", dial: "+34", name: "Spain" },
  { iso: "NL", flag: "🇳🇱", dial: "+31", name: "Netherlands" },
  { iso: "BE", flag: "🇧🇪", dial: "+32", name: "Belgium" },
  { iso: "PT", flag: "🇵🇹", dial: "+351", name: "Portugal" },
  { iso: "LU", flag: "🇱🇺", dial: "+352", name: "Luxembourg" },
  { iso: "IE", flag: "🇮🇪", dial: "+353", name: "Ireland" },
  { iso: "DK", flag: "🇩🇰", dial: "+45", name: "Denmark" },
  { iso: "SE", flag: "🇸🇪", dial: "+46", name: "Sweden" },
  { iso: "NO", flag: "🇳🇴", dial: "+47", name: "Norway" },
  { iso: "FI", flag: "🇫🇮", dial: "+358", name: "Finland" },
  { iso: "PL", flag: "🇵🇱", dial: "+48", name: "Poland" },
  { iso: "CZ", flag: "🇨🇿", dial: "+420", name: "Czech Republic" },
  { iso: "SK", flag: "🇸🇰", dial: "+421", name: "Slovakia" },
  { iso: "HU", flag: "🇭🇺", dial: "+36", name: "Hungary" },
  { iso: "RO", flag: "🇷🇴", dial: "+40", name: "Romania" },
  { iso: "BG", flag: "🇧🇬", dial: "+359", name: "Bulgaria" },
  { iso: "GR", flag: "🇬🇷", dial: "+30", name: "Greece" },
  { iso: "HR", flag: "🇭🇷", dial: "+385", name: "Croatia" },
  { iso: "SI", flag: "🇸🇮", dial: "+386", name: "Slovenia" },
  { iso: "RS", flag: "🇷🇸", dial: "+381", name: "Serbia" },
  { iso: "BA", flag: "🇧🇦", dial: "+387", name: "Bosnia & Herzegovina" },
  { iso: "MK", flag: "🇲🇰", dial: "+389", name: "North Macedonia" },
  { iso: "AL", flag: "🇦🇱", dial: "+355", name: "Albania" },
  { iso: "XK", flag: "🇽🇰", dial: "+383", name: "Kosovo" },
  { iso: "ME", flag: "🇲🇪", dial: "+382", name: "Montenegro" },
  { iso: "TR", flag: "🇹🇷", dial: "+90", name: "Turkey" },
  { iso: "RU", flag: "🇷🇺", dial: "+7", name: "Russia" },
  { iso: "UA", flag: "🇺🇦", dial: "+380", name: "Ukraine" },
  { iso: "BY", flag: "🇧🇾", dial: "+375", name: "Belarus" },
  { iso: "LT", flag: "🇱🇹", dial: "+370", name: "Lithuania" },
  { iso: "LV", flag: "🇱🇻", dial: "+371", name: "Latvia" },
  { iso: "EE", flag: "🇪🇪", dial: "+372", name: "Estonia" },
  { iso: "IS", flag: "🇮🇸", dial: "+354", name: "Iceland" },
  { iso: "MT", flag: "🇲🇹", dial: "+356", name: "Malta" },
  { iso: "CY", flag: "🇨🇾", dial: "+357", name: "Cyprus" },
  { iso: "CA", flag: "🇨🇦", dial: "+1", name: "Canada" },
  { iso: "MX", flag: "🇲🇽", dial: "+52", name: "Mexico" },
  { iso: "BR", flag: "🇧🇷", dial: "+55", name: "Brazil" },
  { iso: "AR", flag: "🇦🇷", dial: "+54", name: "Argentina" },
  { iso: "CL", flag: "🇨🇱", dial: "+56", name: "Chile" },
  { iso: "CO", flag: "🇨🇴", dial: "+57", name: "Colombia" },
  { iso: "AE", flag: "🇦🇪", dial: "+971", name: "United Arab Emirates" },
  { iso: "SA", flag: "🇸🇦", dial: "+966", name: "Saudi Arabia" },
  { iso: "QA", flag: "🇶🇦", dial: "+974", name: "Qatar" },
  { iso: "KW", flag: "🇰🇼", dial: "+965", name: "Kuwait" },
  { iso: "BH", flag: "🇧🇭", dial: "+973", name: "Bahrain" },
  { iso: "OM", flag: "🇴🇲", dial: "+968", name: "Oman" },
  { iso: "IL", flag: "🇮🇱", dial: "+972", name: "Israel" },
  { iso: "JO", flag: "🇯🇴", dial: "+962", name: "Jordan" },
  { iso: "LB", flag: "🇱🇧", dial: "+961", name: "Lebanon" },
  { iso: "IQ", flag: "🇮🇶", dial: "+964", name: "Iraq" },
  { iso: "IR", flag: "🇮🇷", dial: "+98", name: "Iran" },
  { iso: "EG", flag: "🇪🇬", dial: "+20", name: "Egypt" },
  { iso: "MA", flag: "🇲🇦", dial: "+212", name: "Morocco" },
  { iso: "DZ", flag: "🇩🇿", dial: "+213", name: "Algeria" },
  { iso: "TN", flag: "🇹🇳", dial: "+216", name: "Tunisia" },
  { iso: "ZA", flag: "🇿🇦", dial: "+27", name: "South Africa" },
  { iso: "NG", flag: "🇳🇬", dial: "+234", name: "Nigeria" },
  { iso: "KE", flag: "🇰🇪", dial: "+254", name: "Kenya" },
  { iso: "ET", flag: "🇪🇹", dial: "+251", name: "Ethiopia" },
  { iso: "IN", flag: "🇮🇳", dial: "+91", name: "India" },
  { iso: "PK", flag: "🇵🇰", dial: "+92", name: "Pakistan" },
  { iso: "BD", flag: "🇧🇩", dial: "+880", name: "Bangladesh" },
  { iso: "LK", flag: "🇱🇰", dial: "+94", name: "Sri Lanka" },
  { iso: "CN", flag: "🇨🇳", dial: "+86", name: "China" },
  { iso: "HK", flag: "🇭🇰", dial: "+852", name: "Hong Kong" },
  { iso: "TW", flag: "🇹🇼", dial: "+886", name: "Taiwan" },
  { iso: "JP", flag: "🇯🇵", dial: "+81", name: "Japan" },
  { iso: "KR", flag: "🇰🇷", dial: "+82", name: "South Korea" },
  { iso: "SG", flag: "🇸🇬", dial: "+65", name: "Singapore" },
  { iso: "MY", flag: "🇲🇾", dial: "+60", name: "Malaysia" },
  { iso: "TH", flag: "🇹🇭", dial: "+66", name: "Thailand" },
  { iso: "ID", flag: "🇮🇩", dial: "+62", name: "Indonesia" },
  { iso: "PH", flag: "🇵🇭", dial: "+63", name: "Philippines" },
  { iso: "VN", flag: "🇻🇳", dial: "+84", name: "Vietnam" },
  { iso: "AU", flag: "🇦🇺", dial: "+61", name: "Australia" },
  { iso: "NZ", flag: "🇳🇿", dial: "+64", name: "New Zealand" },
];
